import Service from '@/services/abstract/service'

export default class Adm extends Service {
  constructor() {
    super()
    this._leadRef = this._db.collection(`${this._prefix}-leads`)
    this._rankRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Rank`
    )
  }

  separar(base, maximo) {
    let resultado = [[]]
    let grupo = 0

    for (let i = 0; i < base.length; i++) {
      resultado[grupo].push(base[i])
      if (resultado[grupo].length === maximo) {
        grupo++
        resultado.push([])
      }
    }

    return resultado
  }

  async getLeads(dateStart, dateEnd, empresas) {
    try {
      this._loading.setLoading(true, 'Carregando Leads')

      const groupsEmpresas = this.separar(empresas, 10)

      const dataFim = new Date(dateEnd)
      dataFim.setDate(dataFim.getDate() + 1)
      dataFim.setHours(23, 59, 59)

      const dataInicio = new Date(dateStart)
      dataInicio.setDate(dataInicio.getDate() + 1)
      dataInicio.setHours(0)

      let leads = new Array()
      for (const group of groupsEmpresas) {
        const response = await this._leadRef
          .where('empresa', 'in', group)
          .where('dataCriacao', '>=', dataInicio)
          .where('dataCriacao', '<=', dataFim)
          .get()

        if (!response.empty) {
          for (let doc of response.docs) {
            leads.push(doc.data())
          }
        }
      }

      return Promise.resolve(leads)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getRanks() {
    try {
      this._loading.setLoading(true, 'Carregando Rank')

      const dateStart = new Date()
      dateStart.setDate(1)
      const date = new Date()
      date.setMonth(date.getMonth() + 1, 0)
      const dateEnd = date

      const response = await this._rankRef
        .where('dataUltimaAtualizacao', '>=', dateStart)
        .where('dataUltimaAtualizacao', '<=', dateEnd)
        .get()

      let rank = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          rank.push(doc.data())
        }
      }

      return Promise.resolve(rank)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getHistoricoRanks(empresas) {
    try {
      this._loading.setLoading(true, 'Carregando Historico do Rank')

      const groupsEmpresas = this.separar(empresas, 10)

      let dateStart = new Date()
      dateStart.setMonth(dateStart.getMonth() - 6)
      let dateEnd = new Date()

      let ranks = new Array()
      for (const group of groupsEmpresas) {
        const response = await this._rankRef
          .where('empresa', 'in', group)
          .where('dataUltimaAtualizacao', '>=', dateStart)
          .where('dataUltimaAtualizacao', '<=', dateEnd)
          .orderBy('dataUltimaAtualizacao', 'asc')
          .get()

        if (!response.empty) {
          for (let doc of response.docs) {
            ranks.push(doc.data())
          }
        }
      }

      return Promise.resolve(ranks)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
